import { Injectable } from '@angular/core';
import { IIDolOloRequestStore } from './iidOlOloRequest.store';
import { IID_OL_OLOREQUEST } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolOloRequestQuery } from './iidOlOloRequest.query'
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.OLO_REQUEST)
export class IIDolOloRequestService extends CrudService<IID_OL_OLOREQUEST, IIDolOloRequestStore, IIDolOloRequestQuery> {
  constructor(
    protected store: IIDolOloRequestStore,
    public query: IIDolOloRequestQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(
      Topics.IID_OL_OLO_REQUEST,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

}
